import type { BusinessMeResponseType } from "@sellar-io/api-v2/types";
import { useQuery } from "@tanstack/react-query";
import { useFirebaseUser } from "../../../useFirebaseUser.shared";
import { useSellarCurrentBusiness } from "../../../useSellarCurrentBusiness.shared";
import {
  apiV2AssertResponse,
  ApiV2QueryOptions,
  apiV2Request,
  getDefaultQueryOptions,
} from "../apiV2Request";
import { ServerStateKeys } from "../ServerStateKeys";

export const useCurrentBusinessUser = <TData = BusinessMeResponseType,>(
  businessId?: number,
  options?: ApiV2QueryOptions<TData>,
) => {
  const currentBusinessContext = useSellarCurrentBusiness();
  const { user } = useFirebaseUser();

  return useQuery({
    queryKey: [
      user?.uid,
      currentBusinessContext?.business?.id,
      ServerStateKeys.BusinessUser,
      businessId,
    ],

    queryFn: () =>
      apiV2Request({
        user,
        business: currentBusinessContext?.business ?? null,
        method: "get",
        path: `businesses/${businessId}/me`,
      }).then((response) => apiV2AssertResponse<TData>(response).data),
    ...getDefaultQueryOptions(options),
  });
};
